<template>
    <div class="shopping-wrap ptb-100">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6 col-12 order-lg-1 order-2">
                    <div class="shopping-content">
                        <img src="../../assets/images/shopping/shopping-shape-1.png" alt="Image" class="shopping-shape-one moveHorizontal">
                        <img src="../../assets/images/shopping/shopping-shape-2.png" alt="Image" class="shopping-shape-two bounce">
                        <div class="content-title style1 ">
                            <h2 class="header-blue-tf-color">Annual Report 2024</h2>
                            <p>
                                We are pleased to share our abbreviated financial statements for the year 2024. This annual report provides a summary of our financial performance and key developments over the past year. You can download the report in PDF format below.
                            </p>
                        </div>
                        <a href="/docs/A-33713_Macks_Total_Finance_VBA_Abbreviated_Financial_Statements_2024_for_publication.pdf" class="btn style1 m-1" target="_blank">Download abbreviated report</a>
                        <a href="/docs/A-33650_Macks_Total_Finance_VBA_Financial_Statements_2024_for_publication.pdf" class="btn style1 m-1" target="_blank">Download complete report</a>
                    </div>
                </div>
                <div class="col-lg-6 col-12 order-lg-2 order-1">
                    <div class="shopping-img-wrap">
                        <img src="../../assets/images/annual-report/annual-report.png" alt="Image">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AnnualReport'
}
</script>